import { render, staticRenderFns } from "./OpdGroupPageComponent.vue?vue&type=template&id=275698f7&scoped=true&"
import script from "./OpdGroupPageComponent.vue?vue&type=script&lang=js&"
export * from "./OpdGroupPageComponent.vue?vue&type=script&lang=js&"
import style0 from "./OpdGroupPageComponent.vue?vue&type=style&index=0&id=275698f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275698f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
